
import { FREE_TEXT, HANDYMAN_PLAN_COST, HANDYMAN_TEXT, PRO_PLAN_COST, PRO_TEXT } from "@/constants";
import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component({ name: "SwitchPlanConfirmationModal" })
export default class SwitchPlanConfirmationModal extends Vue {

    @Prop({ type: Boolean, default: false }) showModal;
    @Prop({ type: String }) planToSwitchTo;
    @Emit() modalHidden (switchPlans: boolean): boolean { return switchPlans; }

    freeText = FREE_TEXT;
    handymanText = HANDYMAN_TEXT;
    proText = PRO_TEXT;

    handymanPlanCost = HANDYMAN_PLAN_COST;
    proPlanCost = PRO_PLAN_COST;

    get existingPlan() {
        return this.$store.getters.getUserCurrentPlan;
    }

    hideModal(switchPlans = false): void {
        this.modalHidden(switchPlans);
    }
}
